<template>
  <div class="min-h-screen bg-gradient-to-b from-[#142a4a] via-[#18365f] to-[#1b4475]">
    <Navbar :user="user" :tenant-admin="isTenantAdmin" />

    <Users v-if="view === 'users'" class="pt-20" />
    <Agents
      v-else-if="view === 'agents-coordinators'"
      :key="'agents-coordinators'"
      class="pt-20"
      fixed-agent-type="coordinator"
      :tenant-admin="isTenantAdmin"
    />
    <Agents
      v-else-if="view === 'agents-executors'"
      :key="'agents-executors'"
      class="pt-20"
      fixed-agent-type="executor"
      :tenant-admin="isTenantAdmin"
    />
    <Agents
      v-else-if="view === 'agents-network'"
      :key="'agents-network'"
      class="pt-20"
      :start-in-network-mode="true"
      :tenant-admin="isTenantAdmin"
    />
    <AgentSchedulesList v-else-if="view === 'agents-schedules'" class="pt-20" :tenant-admin="isTenantAdmin" />
    <Profile
      v-else-if="view === 'profile'"
      class="pt-20"
      :user="user"
      @user-updated="$emit('user-updated', $event)"
    />
    <TenantSettings v-else-if="view === 'tenant-settings'" class="pt-20" />
    <ApiConnectors v-else-if="view === 'api-connectors'" class="pt-20" />
    <DatabaseConnectors v-else-if="view === 'database-connectors'" class="pt-20" />
    <EmailDeliveryConnectors v-else-if="view === 'email-delivery-connectors'" class="pt-20" />
    <EmailInboxConnectors v-else-if="view === 'email-inbox-connectors'" class="pt-20" />
    <WhatsappDeliveryConnectors v-else-if="view === 'whatsapp-delivery-connectors'" class="pt-20" />
    <CoordinatorGroups v-else-if="view === 'coordinator-groups'" class="pt-20" />
    <CoordinatorChat v-else-if="view === 'coordinator-chat'" />
    <AgentRunLogs v-else-if="view === 'agent-run-logs'" class="pt-20" />
    <AgentDashboard v-else class="pt-20" />
  </div>
</template>

<script>
import Navbar from './Navbar.vue'
import Users from './Users.vue'
import Agents from './Agents.vue'
import AgentDashboard from './AgentDashboard.vue'
import AgentRunLogs from './AgentRunLogs.vue'
import Profile from './Profile.vue'
import TenantSettings from './TenantSettings.vue'
import ApiConnectors from './ApiConnectors.vue'
import DatabaseConnectors from './DatabaseConnectors.vue'
import EmailDeliveryConnectors from './EmailDeliveryConnectors.vue'
import EmailInboxConnectors from './EmailInboxConnectors.vue'
import WhatsappDeliveryConnectors from './WhatsappDeliveryConnectors.vue'
import CoordinatorGroups from './CoordinatorGroups.vue'
import AgentSchedulesList from './AgentSchedulesList.vue'
import CoordinatorChat from './CoordinatorChat.vue'
import { router, navigateTo } from '../router.js'
import { applyLoggedInPageMeta } from '../utils/pageMeta'

const NON_ADMIN_ROUTES = new Set([
  'agent-dashboard',
  'agent-run-logs',
  'agents-network',
  'coordinator-chat',
  'profile'
])

export default {
  components: {
    Navbar,
    Users,
    Agents,
    AgentDashboard,
    AgentRunLogs,
    Profile,
    TenantSettings,
    ApiConnectors,
    DatabaseConnectors,
    EmailDeliveryConnectors,
    EmailInboxConnectors,
    WhatsappDeliveryConnectors,
    CoordinatorGroups,
    CoordinatorChat,
    AgentSchedulesList
  },

  emits: ['user-updated'],

  props: {
    user: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      router
    }
  },

  computed: {
    /** Sem `admin` no objeto (localStorage antigo) = tratar como administrador. */
    isTenantAdmin() {
      if (!this.user) return false
      if (!Object.prototype.hasOwnProperty.call(this.user, 'admin')) return true
      return !!this.user.admin
    },

    view() {
      const r = this.router.currentRoute
      if (
        r === 'users' ||
        r === 'agents-coordinators' ||
        r === 'agents-executors' ||
        r === 'agents-network' ||
        r === 'agents-schedules' ||
        r === 'profile' ||
        r === 'tenant-settings' ||
        r === 'api-connectors' ||
        r === 'database-connectors' ||
        r === 'email-delivery-connectors' ||
        r === 'email-inbox-connectors' ||
        r === 'whatsapp-delivery-connectors' ||
        r === 'coordinator-groups' ||
        r === 'coordinator-chat' ||
        r === 'agent-dashboard' ||
        r === 'agent-run-logs'
      ) {
        return r
      }
      return 'agent-dashboard'
    }
  },

  watch: {
    'router.currentRoute'() {
      this.enforceTenantRoleRoutes()
      this.syncPageMeta()
    },
    user: {
      deep: true,
      handler() {
        this.enforceTenantRoleRoutes()
      }
    }
  },

  mounted() {
    const r = this.router.currentRoute
    if (r === 'agent-network' || r === 'agents') {
      navigateTo(r === 'agent-network' ? 'agents-network' : 'agents-coordinators')
    }
    this.enforceTenantRoleRoutes()
    this.syncPageMeta()
  },

  methods: {
    enforceTenantRoleRoutes() {
      if (!this.user || this.user.admin) return
      const r = this.router.currentRoute
      if (!NON_ADMIN_ROUTES.has(r)) {
        navigateTo('agent-dashboard')
      }
    },

    syncPageMeta() {
      applyLoggedInPageMeta(this.view)
    }
  }
}
</script>
